import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { outerPages } from "src/config/host";
import { AuthContext } from "src/context/auth";
import { SiteContext } from "src/context/site";
import Layout from "src/layouts/Layout";
import { apiRequest } from "./async/apiUtils";
import { setBrowserStyleProperties } from "./helpers/setBrowserStyleProperties";
import { applyCustomFont, applyGlobalHtml } from "./helpers/appHelper";
import { AutoHideScrollbarProvider } from "./context/AutoHideScrollbarContext";

function App() {
  const [siteLoading, setSiteLoading] = useState(true);
  const [site, setSite] = useState({});
  const [user, setUser] = useState(null);

  const loadSiteSettings = useCallback(() => {
    return (async () => {
      setSiteLoading(true);

      try {
        const url = "portal/site-settings/details";
        const { data: resData } = await apiRequest("GET", `/${url}`);

        const data = resData.data;

        setSite(data);

        return data;
      } catch (err) {
        toast.error(err.message);
      } finally {
        setSiteLoading(false);
      }
    })();
  }, []);

  const isOuterPage = outerPages.includes(window.location.pathname) || window.location.href.includes("/token/") || window.location.href.includes("/forgot-password/") || window.location.href.includes("/storage");

  useEffect(() => {
    if (isOuterPage) {
      setBrowserStyleProperties(document, site);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?._id, isOuterPage]);

  useEffect(() => {
    loadSiteSettings();
  }, [loadSiteSettings]);

  useEffect(() => {
    return applyCustomFont(site);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site?.custom_font_details, site?.use_custom_font]);

  useEffect(() => {
    if (site?.global_html && user?._id) {
      return applyGlobalHtml(site?.global_html);
    }
  }, [site?.global_html, user?._id]);

  return (
    <SiteContext.Provider
      value={{
        loading: siteLoading,
        site,
        setSite,
        reloadSettings: loadSiteSettings,
      }}>
      <AuthContext.Provider value={{ user, setUser }}>
        <AutoHideScrollbarProvider
          delay={500}
          thickness={6}
          radius={8}
          track="transparent"
          thumbOpacity={0.4}
          mode="global">
          <Layout />
        </AutoHideScrollbarProvider>
      </AuthContext.Provider>
    </SiteContext.Provider>
  );
}

export default App;
